import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AddBox from '@material-ui/icons/AddBoxOutlined';
import Cancel from '@material-ui/icons/CancelOutlined';
import { IconButton } from '@material-ui/core';
import { actions } from '../../store/nav';

export function ActionButtonImpl({ showActions, visible, onClick }) {
  const icon = showActions ? <Cancel color="secondary" fontSize="large" /> : <AddBox color="secondary" fontSize="large" />;
  if (visible) {
    return (
      <IconButton
        color="secondary"
        style={{ margin: 'auto' }}
        onClick={onClick}
      >
        {icon}
      </IconButton>
    );
  }

  return '';
}

ActionButtonImpl.propTypes = {
  showActions: PropTypes.bool.isRequired,
  visible: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export function mapStateToProps(state) {
  return {
    showActions: state.nav.showActions,
    visible: state.nav.items.filter((i) => i.type === 'action').length > 0,
  };
}

const mapDispatchToProps = {
  onClick: actions.showActions,
};

export default connect(mapStateToProps, mapDispatchToProps)(((ActionButtonImpl)));
